'use client';

export default function UtiqRevokeConsentLink() {
  return (
    <a
      href="#"
      onClick={(event) => {
        event.preventDefault();
        window.Utiq.API.revokeConsentWithPopup();
      }}
    >
      Utiq Einwilligung widerrufen
    </a>
  );
}
